import React from 'react'

const Privilegecard = () => {
  return (
    <div>Privilegecard</div>
  )
}

export default Privilegecard